import { useStoreSelector } from 'hooks/store'
import { Trans, useTranslation } from 'react-i18next'
import styles from '../User.module.scss'
import { routes } from 'types/routes'
import Link from 'components/link/Link'
import AddressSwitcherBar from 'components/address-switcher-bar/AddressSwitcherBar'
import { Banner } from '@boltenergy-be/design-system'
import { selectCurrentAccount } from 'store/contact/slice.ts'
import { trackEvent } from 'utils/tracking.ts'

const Payment = () => {
  // Redux
  const account = useStoreSelector(selectCurrentAccount)

  // i18n
  const { t } = useTranslation(['user', 'common', 'errors'])

  return (
    <section className={styles['table-wrapper']}>
      <AddressSwitcherBar />

      {!account?.paymentDetails?.iban && (
        <Banner type="warning" title={t(($) => $.payment.ibanWarning.title)}>
          <Trans
            i18nKey={($) => $.payment.ibanWarning.description}
            ns="user"
            {...{ t }}
            components={[<Link variant="inline" key="edit-iban" href={routes.USER_EDIT_PAYMENT} />]}
          />
        </Banner>
      )}

      {account.paymentDetails ? (
        <>
          <ul className={styles.table}>
            <li>
              <strong>{t(($) => $.payment.fields.paymentMethod.title)}</strong>
              {account.paymentDetails.directDebit
                ? t(($) => $.payment.fields.paymentMethod.directDebit)
                : t(($) => $.payment.fields.paymentMethod.bankTransfer)}
            </li>

            <li>
              <strong>{t(($) => $.payment.fields.financial.iban)}</strong>
              {account.paymentDetails.iban || '—'}
            </li>

            <li>
              <strong>{t(($) => $.payment.fields.financial.mandate)}</strong>
              {account.paymentDetails.mandateNumber || '—'}
            </li>
          </ul>

          <Link
            representation="button"
            isFullwidthMobile
            className={styles.edit}
            variant="secondary"
            href={routes.USER_EDIT_PAYMENT}
            onNavigate={() => trackEvent({ category: 'user', object: 'edit_payment_info', action: 'start' })}
          >
            {t(($) => $.edit, {
              ns: 'common'
            })}
          </Link>
        </>
      ) : (
        <Banner
          type="blocking"
          title={t(($) => $.default, {
            ns: 'errors'
          })}
        />
      )}
    </section>
  )
}

export default Payment
